import React from 'react'
import * as d3 from "./d3.modified.js"
import Dropdown from './Dropdown'
import Toggler from './Toggler'
import SearchOps from './SearchOps'
import constants from '../ndbk-constants'

class ItemList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selection: [],
            lastClick: -1
        }
    }

    componentDidMount() {
        this.postModifiers()
    }

    componentDidUpdate() {
        this.postModifiers()
    }

    postModifiers = () => {
        this.itemListDiv
            .on('keydown', ()=>{
                // arror up
                if (d3.event.keyCode===38) {
                    d3.event.preventDefault()
                    let id = (this.state.lastClick === -1)? 0 : (this.state.lastClick-1+this.props.items.length)%this.props.items.length
                    this.clickHandler(d3.event,this.props.identifier(this.props.items[id]),id)
                }
                // arrow down
                if (d3.event.keyCode===40) {
                    d3.event.preventDefault()
                    let id =(this.state.lastClick === -1)? 0 : (this.state.lastClick+1+this.props.items.length)%this.props.items.length
                    this.clickHandler(d3.event,this.props.identifier(this.props.items[id]),id)
                }
                // F button
                if (70 === d3.event.keyCode && this.props.transformToSelection) {
                    this.props.transformToSelection()
                }
                // R button
                if (82 === d3.event.keyCode && this.props.transformToSelection) {
                    this.props.transformToSelection(true)
                }
            })
    }

    clickHandler = (e, id, orderId) => {
        if (e.ctrlKey) {
            var iof = this.state.selection.indexOf(id)
            if (iof===-1) {
                this.state.selection.push(id)
                this.setState({
                    selection: this.state.selection,
                    lastClick: orderId
                    }, ()=>{
                        this.props.onChange(this.state.selection)
                })
            } else {
                this.state.selection.splice(iof,1)
                this.setState({
                    selection: this.state.selection,
                    lastClick: orderId
                }, ()=>{
                    this.props.onChange(this.state.selection)
                })
            }
        }

        else if (e.shiftKey) {
            var minId = (orderId<this.state.lastClick?orderId:this.state.lastClick)
            var maxId = (orderId>=this.state.lastClick?orderId:this.state.lastClick)
            for (var i=minId; i<=maxId; i++) {
                var item = this.props.items[i]
                var itemId = this.props.identifier(item)
                var iof = this.state.selection.indexOf(itemId)
                if (iof===-1) {
                    this.state.selection.push(itemId)
                }
            }
            this.setState({
                selection: this.state.selection
            }, ()=>{
                this.props.onChange(this.state.selection)
            })
        }

        else {
            this.setState({
                selection: [id],
                lastClick: orderId
            }, ()=>{
                this.props.onChange(this.state.selection)
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        this.props.items.forEach(item=>{
            if (item._jsx) {
                item._jsx.styleDeselect()
            }
        })

        nextProps.items.forEach(item=>{
            if (item._jsx) {
                if ((this.state.selection.indexOf(nextProps.identifier(item))!==-1)) {
                    item._jsx.styleSelect()
                }
            }
        })
    }

    render() {
        if (this.props.items.length===0 && !this.props.skipEmpty) {
            return (
                <div className={this.props.className} ref={c=>this.itemListDiv=d3.select(c)} tabIndex="-1">
                    <p className="noitems">No match.</p>
                </div>
            )
        }

        // accessor on item click (onChange)

        return (
            <div className={this.props.className} ref={c=>this.itemListDiv=d3.select(c)} tabIndex={this.props.listTabIndex}>
                {
                    this.props.items.map(
                        (item, id) => {
                            var isSelected = (this.state.selection.indexOf(this.props.identifier(item))!==-1)
                            return (
                                <div
                                    key={this.props.identifier(item)}
                                    onClick={e=>{this.clickHandler(e,this.props.identifier(item),id)}}
                                    ref={c=>item._itemListRef=d3.select(c)}
                                    className={this.props.childClassName+(isSelected?' selected':'')}
                                    onDoubleClick={e=>{if(this.props.onDoubleClick) {this.props.onDoubleClick()}}}
                                >
                                    {this.props.accessor(item)}
                                </div>
                            )
                        }

                    )
                }
            </div>
        )
    }
}

export default class NodebookSidebar extends React./*Pure*/Component {
    constructor(props) {
        super(props)
        this.state = {
            chosenProperty: '_title',
            chosenValue: [],
            availableVals: [],
            availableGroups: [],
            // ascending: true,
            filteredNodes: [],
            combineFiltersAnd: false,
            showFilter: true
        }

        this.filterOptions = {
            _title: 'None',
            authors: 'Authors',
            year: 'Year',
            journal: 'Publication',
            tags: 'Tags',
            keywords: 'Keywords',
            group: 'Search results',
            color: 'Color',
        }

        this.filterOptionsNoSearch = {
            _title: 'None',
            authors: 'Authors',
            year: 'Year',
            journal: 'Publication',
            tags: 'Tags',
            keywords: 'Keywords',
            color: 'Color',
        }
    }

    componentDidMount() {
        this.updateFilters()
        this.filterData()

        let showFilter = localStorage.getItem('show-sidebar-filter')
        if (showFilter === 'false') {
            this.setState({showFilter: false})
        }

    }

    componentWillReceiveProps(nextProps) {
        this.props = nextProps;
        this.updateFilters()
        this.filterData()
    }

    selectionChangeHandler = (change) => {
        this.filteredNodesRef.setState({selection: this.props.getSelection().nodes})
    }

    filterData = () => {
        var filteredNodes = []
        if (this.state.chosenProperty==='group') {
            var allNodes = new Set()
            var _dd = false

            for (var i=0; i<this.state.chosenValue.length; i++) {
                var groupName = this.state.chosenValue[i]
                for (var j=0; j<this.state.availableGroups.length; j++) {
                    var _group = this.state.availableGroups[j]
                    if ((_group.value+j)===groupName) {
                        if (!this.state.combineFiltersAnd) {
                            SearchOps.unionInplace(allNodes, _group._set)
                        } else {
                            if (!_dd) {
                                allNodes = new Set(_group._set)
                                _dd = true
                            } else {
                                allNodes = SearchOps.intersect(allNodes, _group._set)
                            }
                        }
                        break
                    }
                }
            }

            allNodes.forEach(
                nodeId => filteredNodes.push(this.props.nodesData[this.props.nodesHashTable[nodeId]])
            )
        } else if (this.state.chosenProperty==='_title') {
            this.props.nodesData.forEach(node=>filteredNodes.push(node))
        } else {
            this.props.nodesData.forEach(
                node => {
                    var prop = node.properties[this.state.chosenProperty]
                    var satisfiesCond = false

                    if (this.state.combineFiltersAnd) {
                        // AND filters
                        satisfiesCond = true
                        for (var i=0; i<this.state.chosenValue.length; i++) {
                            if (!prop || !prop.toString().toLowerCase().match(this.state.chosenValue[i])) {
                                satisfiesCond = false
                                break
                            }
                        }
                    } else {
                        // OR filters
                        for (var i=0; i<this.state.chosenValue.length; i++) {
                            if (prop && prop.toString().toLowerCase().match(this.state.chosenValue[i])) {
                                satisfiesCond = true
                                break
                            }
                        }

                        if (this.state.chosenValue.length===0) {
                            satisfiesCond = true
                        }
                    }

                    if (satisfiesCond) {
                        filteredNodes.push(node)
                    }
                }
            )
        }
        filteredNodes = filteredNodes.filter(node=>(node!==undefined))
        filteredNodes.sort((a,b)=>{
            if (a.properties.title==='') return 1
            if (b.properties.title==='') return -1
            if (a.properties.title<b.properties.title) return -1
            if (a.properties.title>b.properties.title) return 1
            return 0
        })
        this.setState({filteredNodes: filteredNodes})
    }

    updateFilters = () => {
        var vals = []
        if (this.state.chosenProperty==='group') {
            this.state.availableGroups.forEach(
                (gr,id) => vals.push({label: gr.value?gr.value:'(unnamed group)', key: gr.value+id})
            )
        } else if (this.state.chosenProperty==='_title') {
            vals = []
        } else {
            this.props.nodesData.forEach(
                node => {
                    var prop = node.properties[this.state.chosenProperty]
                    if (this.state.chosenProperty==='authors' ||
                        this.state.chosenProperty==='tags' ||
                        this.state.chosenProperty==='keywords') {

                        if (prop && Array.isArray(prop)) {
                            prop.forEach(
                                val => {
                                    if (!this.hasKey(vals, val.toLowerCase())) {
                                        vals.push({label: val, key: val.toLowerCase()})
                                    }
                                }
                            )
                        }
                    } else {
                        if (prop && prop!=='' && !this.hasKey(vals, prop.toLowerCase())) {
                            vals.push({label: prop, key: prop.toLowerCase()})
                        }
                    }
            })
        }
        vals.sort((a,b)=>{
            if (!a.key) return -1
            if (!b.key) return 1
            if (a.key<b.key) return -1
            if (a.key>b.key) return 1
            return 0
        })
        this.setState({availableVals: vals})
    }

    forceShowResults = (availableGroups, resultsLabel) => {
        this.setState({
            chosenProperty: 'group',
            chosenValue: resultsLabel?[resultsLabel+'0']:[],
            availableGroups: availableGroups,
            combineFiltersAnd: false
        }, ()=>{
            this.updateFilters()
            this.filterData()
            if (this.filtersRef) {
                this.filtersRef.setState({selection: this.state.chosenValue})
            }
        })
    }

    forceUpdateResults = (availableGroups) => {
        if (availableGroups.length===0) {
            this.setState({
                chosenProperty: '_title',
                availableGroups: [],
                chosenValue: []
            }, ()=>{
                this.updateFilters()
                this.filterData()
                if (this.filtersRef) {
                    this.filtersRef.setState({selection: this.state.chosenValue})
                }
            })
            return
        }

        if (availableGroups.length===1 && this.state.availableGroups.length===0) {
            this.setState({
                chosenProperty: 'group',
                availableGroups: availableGroups,
                chosenValue: [availableGroups[0].value+'0']
            }, ()=>{
                this.updateFilters()
                this.filterData()
                if (this.filtersRef) {
                    this.filtersRef.setState({selection: this.state.chosenValue})
                }
            })
            return
        }

        var newChoseValues = []
        if (availableGroups.length===this.state.availableGroups.length) {
            this.state.chosenValue.forEach(
                val => {
                    var valId = -1
                    this.state.availableGroups.forEach(
                        (group, id) => {
                            if ((group.value+id)===val) {
                                valId = id
                            }
                        }
                    )
                    if (valId!==-1) {
                        newChoseValues.push(availableGroups[valId].value+valId)
                    }
                }
            )
        }


        this.setState({
            chosenProperty: 'group',
            availableGroups: availableGroups,
            chosenValue: newChoseValues
        }, ()=>{
            this.updateFilters()
            this.filterData()
            if (this.filtersRef) {
                this.filtersRef.setState({selection: this.state.chosenValue})
            }
        })
    }

    hasKey = (vals, key) => {
        for (var i=0; i<vals.length; i++) {
            if (vals[i].key===key) {
                return true
            }
        }
        return false
    }

    toggleFilter = (e) => {
        e.stopPropagation()
        let showFilter = !this.state.showFilter;
        this.setState({showFilter:!this.state.showFilter})
        localStorage.setItem('show-sidebar-filter', (showFilter===true)?'true':'false')
    }

    openFilter = () => {
        let showFilter = true;
        this.setState({showFilter:showFilter})
        localStorage.setItem('show-sidebar-filter', (showFilter===true)?'true':'false')
    }

    render() {
        if (constants.RENDER_LOGS === true) console.log("<Sidebar> render")
        return (
            <div className="nodebook-sidebar">
                <div className="nodebook-sidebar-filtered">
                    <ItemList
                        listTabIndex="0"
                        childClassName="nodebook-sidebar-item"
                        onChange={sel=>{
                            var nodes = sel.map(nodeId=>this.props.nodesData[this.props.nodesHashTable[nodeId]])
                            this.props.selectMultipleNodes(nodes)
                        }}
                        identifier={item=>item.id}
                        accessor={item=>{ return item.properties.title===''?'(untitled node)':item.properties.title }}
                        items={this.state.filteredNodes}
                        ref={c=>this.filteredNodesRef=c}
                        onDoubleClick={()=>{this.props.transformToSelection(); this.selectionChangeHandler();}}
                        transformToSelection={this.props.transformToSelection}
                    />
                </div>
                <div className="nodebook-sidebar-filter"
                    onClick = {this.openFilter}
                    style={
                        (this.state.showFilter
                            ? {}
                            : {flex:'0 0 auto'})}
                >
                    <p><span
                        title={(this.state.showFilter?'Hide':'Show')+" filters"}
                        style={{cursor: 'pointer'}}
                        onClick={this.toggleFilter}
                        >
                        Filter by:
                        </span> <Dropdown
                            default={this.state.chosenProperty}
                            values={this.state.availableGroups.length>0?this.filterOptions:this.filterOptionsNoSearch}
                            onChange={val=>{
                                this.setState({
                                    chosenProperty: val,
                                    chosenValue: []
                                }, ()=>{
                                    this.updateFilters()
                                    this.filterData()
                                    if (this.filtersRef) {
                                        this.filtersRef.setState({selection: this.state.chosenValue})
                                    }
                                })
                            }}
                        />
                        <span
                            className={"combinator"+(this.state.combineFiltersAnd?' selected':'')}
                            onClick={()=>{
                                this.setState({combineFiltersAnd: true}, ()=>{this.filterData()})
                            }}
                            title="Match all of the selected filters"
                        >All</span>
                        <span
                            className={"combinator"+(!this.state.combineFiltersAnd?' selected':'')}
                            onClick={()=>{
                                this.setState({combineFiltersAnd: false}, ()=>{this.filterData()})
                            }}
                            title="Match any of the selected filters"
                        >Any</span>
                    </p>
                    {
                        (this.state.showFilter)
                            ? (
                                <ItemList
                                    listTabIndex="-1"
                                    skipEmpty
                                    ref={c=>this.filtersRef=c}
                                    className="list"
                                    onChange={sel=>{
                                        this.setState({chosenValue: sel}, ()=>{this.filterData()})
                                    }}
                                    identifier={item=>item.key}
                                    items={this.state.availableVals}

                                    childClassName="nodebook-sidebar-filter-item"
                                    accessor={item=>item.label}
                                />
                            )
                            : null
                    }

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/NodebookSidebar.js